import * as React from "react";
import { CASHFREE_CONFIG } from '../../../config/paymentConfig';
import styled from "styled-components";
import { API_BASE_URL } from '../../../config/apiConfig';
import Snackbar from '@mui/material/Snackbar';
import Save from '../../../assets/profile/profile-save.png';
import Splurge from '../../../assets/profile/profile-splurge.png';
import { buttonIcon } from '../../../assets/images';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';

function Subscription({ profile, setProfile }) {
  const [subscriptionType, setSubscriptionType] = React.useState(profile.subscriptionType || '');
  const [isEditing, setIsEditing] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [gstNumber, setGstNumber] = React.useState(profile.gst || '');
  const [showPricing, setShowPricing] = React.useState(false);
  const [currentSubscription, setCurrentSubscription] = React.useState(null);
  const [hasSubscription, setHasSubscription] = React.useState(false);
  const [subscriptionLoading, setSubscriptionLoading] = React.useState(true);
  const [showSubscriptionDetails, setShowSubscriptionDetails] = React.useState(false);
  const [showPricingModal, setShowPricingModal] = React.useState(false);
  const [showRevokeConfirm, setShowRevokeConfirm] = React.useState(false);
  const [isRevoking, setIsRevoking] = React.useState(false);
  const [isServiceable, setIsServiceable] = React.useState(null); // null=unknown, true/false
  const [serviceabilityMsg, setServiceabilityMsg] = React.useState('');
  const subscriptionBasePrice = 999;
  const subscriptionGstRate = 0.18;
  const subscriptionDiscountPercent = Math.min(
    Math.max(Number(profile?.subscriptionWaivedAmt || 0), 0),
    100
  );
  const subscriptionDiscountAmount = Number(
    ((subscriptionBasePrice * subscriptionDiscountPercent) / 100).toFixed(2)
  );
  const subscriptionDiscountedBaseAmount = Number(
    Math.max(subscriptionBasePrice - subscriptionDiscountAmount, 0).toFixed(2)
  );
  const subscriptionGstAmount = Number(
    (subscriptionDiscountedBaseAmount * subscriptionGstRate).toFixed(2)
  );
  const subscriptionPayableAmount = Number(
    (subscriptionDiscountedBaseAmount + subscriptionGstAmount).toFixed(2)
  );

  console.log(profile);
  
  
  console.log(gstNumber, subscriptionType, profile);
  
  // Fetch current subscription details on component mount
  React.useEffect(() => {
    fetchCurrentSubscription();
  }, []);

  // Check delivery serviceability based on user's pincode
  React.useEffect(() => {
    const pin = profile?.pincode;
    const check = async () => {
      try {
        if (!pin || String(pin).length !== 6) {
          setIsServiceable(null);
          setServiceabilityMsg('');
          return;
        }
        const resp = await fetch(`${API_BASE_URL}/shipping/bluedart/pincode/${pin}`);
        const data = await resp.json();
        console.log('pincodedata:', data);
        if (data?.is_success) {
          const ok = !!data.data?.serviceable;
          setIsServiceable(ok);
          setServiceabilityMsg(ok ? '' : 'Not serviceable currently');
        } else {
          setIsServiceable(false);
          setServiceabilityMsg('');
        }
      } catch (e) {
        setIsServiceable(false);
        setServiceabilityMsg('');
      }
    };
    check();
  }, [profile?.pincode]);

  // Poll for status if pending
  React.useEffect(() => {
    let pollInterval = null;
    if (currentSubscription && currentSubscription.status === 'pending' && currentSubscription.latest_payment && currentSubscription.latest_payment.order_id) {
      const pollStatus = async () => {
        try {
          const token = sessionStorage.getItem('token');
          const response = await fetch(`${API_BASE_URL}/subscription/mandate-status/${currentSubscription.latest_payment.order_id}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: token
            }
          });
          const result = await response.json();
          if (result.is_success && result.data) {
            // If status changed from pending, refresh subscription
            if (result.data.status !== 'pending') {
              fetchCurrentSubscription();
              clearInterval(pollInterval);
            }
          }
        } catch (err) {
          // Ignore errors, will try again on next poll
        }
      };
      pollInterval = setInterval(pollStatus, 10000); // Poll every 10 seconds
    }
    return () => {
      if (pollInterval) clearInterval(pollInterval);
    };
  }, [currentSubscription]);

  const fetchCurrentSubscription = async () => {
    try {
      const token = sessionStorage.getItem('token');
      if (!token) {
        setSubscriptionLoading(false);
        return;
      }

      const response = await fetch(`${API_BASE_URL}/subscription/current`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token
        }
      });

      const result = await response.json();
      
      if (result.is_success) {
        setHasSubscription(result.data.has_subscription);
        setCurrentSubscription(result.data.subscription);
      } else {
        console.error('Failed to fetch subscription:', result.message);
      }
    } catch (error) {
      console.error('Error fetching subscription:', error);
    } finally {
      setSubscriptionLoading(false);
    }
  };
  
  const handleSubscriptionChange = (type) => {
    setSubscriptionType(type);
    setProfile(prevProfile => ({
      ...prevProfile,
      subscriptionType: type
    }));
  };

  const handleSaveClick = async () => {
    const token = sessionStorage.getItem('token');
    const body = {
      subscriptionType,
      profession: profile.profession,
      gst: gstNumber
    };
    setProfile(prevProfile => ({
      ...prevProfile,
      gst: gstNumber
    }));
    
    if (token && body) {
      try {
        const response = await fetch(`${API_BASE_URL}/user/update-profile`, {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
            Authorization: token
          },
          body: JSON.stringify(body)
        });

        if (response.ok) {
          setSnackbarMessage('Profile updated successfully!');
        } else {
          setSnackbarMessage('Failed to update profile. Please try again.');
        }
      } catch (error) {
        console.error('Error updating profile:', error);
        setSnackbarMessage('Error updating profile. Please check your connection.');
      } finally {
        setSnackbarOpen(true);
        setIsEditing(false);
      }
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  // Helper function to format dates
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const formatCurrency = (amount) => `₹${Number(amount || 0).toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`;

  // Helper function to get subscription status display
  const getSubscriptionStatusDisplay = (subscription) => {
    if (!subscription) return { text: 'Unknown', color: '#666' };
    
    const statusMap = {
      'active': { text: 'Active', color: '#4CAF50' },
      'pending': { text: 'Pending', color: '#FF9800' },
      'expired': { text: 'Expired', color: '#F44336' },
      'failed': { text: 'Failed', color: '#F44336' },
      'cancelled': { text: 'Cancelled', color: '#757575' },
      'revoked': { text: 'Revoked', color: '#757575' }
    };
    
    return statusMap[subscription.status] || { text: subscription.status, color: '#666' };
  };

  const handleSubscribe = async () => {
    if (!profile.firstname || !profile.lastname) {
      setSnackbarMessage('Please complete your profile information before subscribing.');
      setSnackbarOpen(true);
      return;
    }

    try {
      console.log(profile);
      const response = await fetch(`${API_BASE_URL}/subscription/create-upi-mandate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: sessionStorage.getItem('token')
        },
        body: JSON.stringify({
          first_name: profile.firstname,
          last_name: profile.lastname,
          customer_email: profile.email,
          customer_phone: profile.mobile,
          customer_name: `${profile.firstname} ${profile.lastname}`

        })
      });

      const result = await response.json();
      
      if (result.is_success) {
        console.log('Subscription response:', result);
        
        // Check if subscription was waived (no payment needed)
        if (result.data?.waived) {
          setSnackbarMessage('Subscription activated successfully! Your subscription fee has been waived.');
          setSnackbarOpen(true);
          setShowPricingModal(false);
          // Refresh subscription data to show active status
          fetchCurrentSubscription();
          return;
        }
        
        setSnackbarMessage('Redirecting to payment...');
        setSnackbarOpen(true);
        
        // Store order_id in session storage for later use
        if (result.data && result.data.order_id) {
          sessionStorage.setItem('current_order_id', result.data.order_id);
          console.log('Stored order_id in sessionStorage:', result.data.order_id);
        }
        
        // Prefer Cashfree SDK with payment_session_id; fallback to link
        const paymentSessionId = result?.data?.payment_session_id;
        const paymentLink = result?.data?.payment_link || result?.data?.cashfree_response?.payment_link || result?.data?.cashfree_response?.payment_links?.web;

        if (paymentSessionId) {
          try {
            const { load: loadCashfree } = await import('@cashfreepayments/cashfree-js');
            const cashfree = await loadCashfree({ mode: CASHFREE_CONFIG.mode });
            await cashfree.checkout({
              paymentSessionId,
              redirectTarget: '_self'
            });
          } catch (e) {
            console.error('Cashfree checkout error, falling back to link:', e);
            if (paymentLink) window.location.href = paymentLink;
          }
        } else if (paymentLink) {
          window.location.href = paymentLink;
        }
      } else {
        setSnackbarMessage(result.message || 'Failed to initiate subscription. Please try again.');
      }
    } catch (error) {
      console.error('Error initiating subscription:', error);
      setSnackbarMessage('Error initiating subscription. Please check your connection.');
    } finally {
      setSnackbarOpen(true);
      // Refresh subscription data after attempting to subscribe
      setTimeout(() => {
        fetchCurrentSubscription();
      }, 2000);
    }
  };

  const handleSubscribeClick = () => {
    setShowPricingModal(true);
  };

  const handleRevokeMandate = async () => {
    if (!currentSubscription || !currentSubscription.mandate || !currentSubscription.mandate.mandate_id) {
      setSnackbarMessage('No active mandate found to revoke.');
      setSnackbarOpen(true);
      return;
    }

    setIsRevoking(true);
    try {
      const response = await fetch(`${API_BASE_URL}/subscription/revoke-mandate/${currentSubscription.mandate.mandate_id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: sessionStorage.getItem('token')
        }
      });

      const result = await response.json();
      
      if (result.is_success) {
        setSnackbarMessage('Mandate revoked successfully. Your subscription has been cancelled.');
        setSnackbarOpen(true);
        setShowRevokeConfirm(false);
        setShowSubscriptionDetails(false);
        // Refresh subscription data
        setTimeout(() => {
          fetchCurrentSubscription();
        }, 1000);
      } else {
        setSnackbarMessage(result.message || 'Failed to revoke mandate. Please try again.');
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error('Error revoking mandate:', error);
      setSnackbarMessage('Error revoking mandate. Please check your connection.');
      setSnackbarOpen(true);
    } finally {
      setIsRevoking(false);
    }
  };

  return (
    <SubscriptionContainer>
      <FormContainer>
        <div style={{ padding: '20px' }}>
          {/* Main Subscription Card */}
          <CurrentSubscriptionSection>
            <SubscriptionHeader>
              <SubscriptionDetailsTitle>CURRENT SUBSCRIPTION</SubscriptionDetailsTitle>
              {hasSubscription && currentSubscription && (
                <ActionButtonsGroup>
                  <ViewDetailsButton onClick={() => setShowSubscriptionDetails(true)}>
                    VIEW DETAILS
                  </ViewDetailsButton>
                  <TabEditButton onClick={() => setIsEditing(!isEditing)}>
                    {isEditing ? 'HIDE EDIT' : 'EDIT'}
                  </TabEditButton>
                </ActionButtonsGroup>
              )}
            </SubscriptionHeader>

            {subscriptionLoading ? (
              <SmallLoader>Loading subscription status...</SmallLoader>
            ) : hasSubscription && currentSubscription ? (
              <CompactSubscriptionView>
                <StatusRow>
                  <StatusInfo>
                    <StatusLabel>Status:</StatusLabel>
                    <StatusValue status={getSubscriptionStatusDisplay(currentSubscription).color}>
                      {getSubscriptionStatusDisplay(currentSubscription).text}
                      {currentSubscription.waived && (
                        <WaivedBadge>WAIVED</WaivedBadge>
                      )}
                    </StatusValue>
                  </StatusInfo>
                  <ValidityInfo>
                    <StatusLabel>Valid Until:</StatusLabel>
                    <StatusValue>
                      {currentSubscription.end_date ? formatDate(currentSubscription.end_date) : 'N/A'}
                    </StatusValue>
                  </ValidityInfo>
                </StatusRow>
              </CompactSubscriptionView>
            ) : (
              <NoSubscriptionView>
                <StatusLabel>You don't have an active subscription.</StatusLabel>
                <MainSubscribeButton onClick={handleSubscribeClick} disabled={isServiceable === false} style={{ marginTop: '15px' }}>
                  <span>SUBSCRIBE NOW</span>
                  <ButtonIcon loading="lazy" src={buttonIcon} alt="" />
                </MainSubscribeButton>
              </NoSubscriptionView>
            )}

            {/* Action CTAs for specific states */}
            {currentSubscription && (
              <div style={{ marginTop: '10px' }}>
                {currentSubscription.status === 'expired' && (
                  <RenewButtonContainer>
                    <RenewButton onClick={handleSubscribeClick}>
                      <span>RENEW SUBSCRIPTION</span>
                      <ButtonIcon loading="lazy" src={buttonIcon} alt="" />
                    </RenewButton>
                  </RenewButtonContainer>
                )}
                {(currentSubscription.status === 'failed' || currentSubscription.status === 'cancelled') && (
                  <RenewButtonContainer>
                    <RenewButton onClick={handleSubscribeClick}>
                      <span>RETRY PAYMENT</span>
                      <ButtonIcon loading="lazy" src={buttonIcon} alt="" />
                    </RenewButton>
                  </RenewButtonContainer>
                )}
              </div>
            )}
          </CurrentSubscriptionSection>

          {/* Collapsible Edit Section */}
          {isEditing && (
            <EditSectionContainer>
              <SectionDivider />
              <RowContainer>
                <SubscriptionFormField>
                  <SubscriptionTitle>I AM</SubscriptionTitle>
                  <UserTypeSelect
                    value={profile ? profile.profession : ''}
                    onChange={(e) => setProfile({ ...profile, profession: e.target.value })}
                  >
                    <option value="student">A student</option>
                    <option value="professional">A working professional</option>
                    <option value="startup">A startup founder</option>
                    <option value="business">A business owner</option>
                    <option value="institution">An institution</option>
                  </UserTypeSelect>
                </SubscriptionFormField>

                {(profile.profession === 'institution' || profile.profession === 'startup' || profile.profession === 'business') && (
                  <SubscriptionFormField>
                    <SubscriptionTitle htmlFor='gstNumber'>GST Number</SubscriptionTitle>
                    <SubscriptionInput
                      type="text"
                      id='gstNumber'
                      value={gstNumber}
                      onChange={(e) => setGstNumber(e.target.value)}
                    />
                  </SubscriptionFormField>
                )}
              </RowContainer>

              <SubscriptionTitle>I WANT TO</SubscriptionTitle>
              <OptionsContainer>
                <Option onClick={() => handleSubscriptionChange('Save')} style={{ cursor: 'pointer' }}>
                  <OptionLeft>
                    <OptionIcon isSelected={subscriptionType === 'Save'} />
                    <OptionTitle>Save</OptionTitle>
                    <OptionDescription>
                      I want to save money on every product purchase
                    </OptionDescription>
                  </OptionLeft>
                  <OptionRight src={Save} alt="Save Image" />
                </Option>
                <Option onClick={() => handleSubscriptionChange('Splurge')} style={{ cursor: 'pointer' }}>
                  <OptionLeft>
                    <OptionIcon isSelected={subscriptionType === 'Splurge'} />
                    <OptionTitle>Splurge</OptionTitle>
                    <OptionDescription>
                      I spend money lavishly and upgrade my products frequently
                    </OptionDescription>
                  </OptionLeft>
                  <OptionRight2 src={Splurge} alt="Splurge Image" />
                </Option>
              </OptionsContainer>
             
              <SaveButton onClick={handleSaveClick}>
                <span>SAVE CHANGES</span>
                <ButtonIcon loading="lazy" src={buttonIcon} alt="" />
              </SaveButton>
            </EditSectionContainer>
          )}
        </div>
      </FormContainer>
      {snackbarOpen && (
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
          message={snackbarMessage}
        />
      )}
      
      {/* Subscription Details Modal */}
      <Modal
        open={showSubscriptionDetails}
        onClose={() => setShowSubscriptionDetails(false)}
        aria-labelledby="subscription-details-title"
      >
        <Box sx={modalStyle}>
          <ModalContent>
            <ModalHeader>
              <ModalTitle>Subscription Details</ModalTitle>
              <CloseButton onClick={() => setShowSubscriptionDetails(false)}>×</CloseButton>
            </ModalHeader>
            {currentSubscription && (
              <ModalBody>
                <DetailRow>
                  <DetailLabel>Plan Type</DetailLabel>
                  <DetailValue>{currentSubscription.plan_type}</DetailValue>
                </DetailRow>
                <DetailRow>
                  <DetailLabel>Status</DetailLabel>
                  <DetailValue status={getSubscriptionStatusDisplay(currentSubscription).color}>
                    {getSubscriptionStatusDisplay(currentSubscription).text}
                    {currentSubscription.waived && ' (Waived)'}
                  </DetailValue>
                </DetailRow>
                <DetailRow>
                  <DetailLabel>Amount</DetailLabel>
                  <DetailValue>
                    {currentSubscription.waived 
                      ? <span style={{ color: '#4CAF50', fontWeight: 600 }}>Free (Waived)</span>
                      : `₹${currentSubscription.amount} ${currentSubscription.currency}`
                    }
                  </DetailValue>
                </DetailRow>
                <DetailRow>
                  <DetailLabel>Frequency</DetailLabel>
                  <DetailValue>{currentSubscription.frequency}</DetailValue>
                </DetailRow>
                {currentSubscription.start_date && (
                  <DetailRow>
                    <DetailLabel>Start Date</DetailLabel>
                    <DetailValue>{formatDate(currentSubscription.start_date)}</DetailValue>
                  </DetailRow>
                )}
                {currentSubscription.end_date && (
                  <DetailRow>
                    <DetailLabel>Valid Until</DetailLabel>
                    <DetailValue>{formatDate(currentSubscription.end_date)}</DetailValue>
                  </DetailRow>
                )}
                {currentSubscription.days_until_expiry !== null && currentSubscription.days_until_expiry >= 0 && (
                  <DetailRow>
                    <DetailLabel>Days Remaining</DetailLabel>
                    <DetailValue>{currentSubscription.days_until_expiry} days</DetailValue>
                  </DetailRow>
                )}
                {currentSubscription.renewal_date && (
                  <DetailRow>
                    <DetailLabel>Next Renewal</DetailLabel>
                    <DetailValue>{formatDate(currentSubscription.renewal_date)}</DetailValue>
                  </DetailRow>
                )}
                {currentSubscription.waived ? (
                  <>
                    <ModalSectionTitle>Payment Information</ModalSectionTitle>
                    <DetailRow>
                      <DetailLabel>Payment Status</DetailLabel>
                      <DetailValue style={{ color: '#4CAF50' }}>Fee Waived</DetailValue>
                    </DetailRow>
                    {currentSubscription.waived_by && (
                      <DetailRow>
                        <DetailLabel>Waived By</DetailLabel>
                        <DetailValue>{currentSubscription.waived_by}</DetailValue>
                      </DetailRow>
                    )}
                  </>
                ) : currentSubscription.latest_payment && (
                  <>
                    <ModalSectionTitle>Latest Payment</ModalSectionTitle>
                    <DetailRow>
                      <DetailLabel>Payment ID</DetailLabel>
                      <DetailValue>{currentSubscription.latest_payment.payment_id}</DetailValue>
                    </DetailRow>
                    <DetailRow>
                      <DetailLabel>Transaction ID</DetailLabel>
                      <DetailValue>{currentSubscription.latest_payment.transaction_id || 'N/A'}</DetailValue>
                    </DetailRow>
                    <DetailRow>
                      <DetailLabel>Payment Status</DetailLabel>
                      <DetailValue>{currentSubscription.latest_payment.status}</DetailValue>
                    </DetailRow>
                  </>
                )}
                {currentSubscription.mandate && (
                  <>
                    <ModalSectionTitle>Mandate Details</ModalSectionTitle>
                    <DetailRow>
                      <DetailLabel>Mandate Status</DetailLabel>
                      <DetailValue>{currentSubscription.mandate.status}</DetailValue>
                    </DetailRow>
                    <DetailRow>
                      <DetailLabel>Max Amount</DetailLabel>
                      <DetailValue>₹{currentSubscription.mandate.max_amount}</DetailValue>
                    </DetailRow>
                    {currentSubscription.mandate.next_execution_date && (
                      <DetailRow>
                        <DetailLabel>Next Execution</DetailLabel>
                        <DetailValue>{formatDate(currentSubscription.mandate.next_execution_date)}</DetailValue>
                      </DetailRow>
                    )}
                    {currentSubscription.mandate.status === 'active' && (
                      <RevokeButtonContainer>
                        <RevokeButton onClick={() => setShowRevokeConfirm(true)}>
                          <span>REVOKE MANDATE</span>
                        </RevokeButton>
                      </RevokeButtonContainer>
                    )}
                  </>
                )}
              </ModalBody>
            )}
          </ModalContent>
        </Box>
      </Modal>
      
      {/* Pricing Modal */}
      <Modal
        open={showPricingModal}
        onClose={() => setShowPricingModal(false)}
        aria-labelledby="pricing-modal-title"
      >
        <Box sx={modalStyle}>
          <ModalContent>
            <ModalHeader>
              <ModalTitle>Subscription Pricing</ModalTitle>
              <CloseButton onClick={() => setShowPricingModal(false)}>×</CloseButton>
            </ModalHeader>
            <ModalBody>
              <PricingBreakdown>
                <PriceRow>
                  <PriceLabel>Base Price (Annual)</PriceLabel>
                  <PriceValue>{formatCurrency(subscriptionBasePrice)}</PriceValue>
                </PriceRow>
                {subscriptionDiscountPercent > 0 && (
                  <PriceRow>
                    <PriceLabel>Discount ({subscriptionDiscountPercent}%)</PriceLabel>
                    <PriceValue>-{formatCurrency(subscriptionDiscountAmount)}</PriceValue>
                  </PriceRow>
                )}
                <PriceRow>
                  <PriceLabel>GST (18%)</PriceLabel>
                  <PriceValue>{formatCurrency(subscriptionGstAmount)}</PriceValue>
                </PriceRow>
                <PriceDivider />
                <PriceRow total>
                  <PriceLabel>Total Amount</PriceLabel>
                  <PriceValue>{formatCurrency(subscriptionPayableAmount)}</PriceValue>
                </PriceRow>
              </PricingBreakdown>
              <SubscribeButtonContainer>
                <SubscribeButton onClick={() => {
                  setShowPricingModal(false);
                  handleSubscribe();
                }} disabled={isServiceable === false}>
                  <span>PROCEED TO PAYMENT</span>
                  <ButtonIcon loading="lazy" src={buttonIcon} alt="" />
                </SubscribeButton>
              </SubscribeButtonContainer>
            </ModalBody>
          </ModalContent>
        </Box>
      </Modal>
      
      {/* Revoke Confirmation Modal */}
      <Modal
        open={showRevokeConfirm}
        onClose={() => !isRevoking && setShowRevokeConfirm(false)}
        aria-labelledby="revoke-confirm-title"
      >
        <Box sx={modalStyle}>
          <ModalContent>
            <ModalHeader>
              <ModalTitle>Confirm Mandate Revocation</ModalTitle>
              {!isRevoking && (
                <CloseButton onClick={() => setShowRevokeConfirm(false)}>×</CloseButton>
              )}
            </ModalHeader>
            <ModalBody>
              <RevokeWarning>
                <WarningText>
                  Are you sure you want to revoke your mandate? <br />This action will:
                </WarningText>
                <WarningList>
                  <WarningItem>Cancel your subscription immediately</WarningItem>
                  <WarningItem>Stop all future automatic payments</WarningItem>
                  <WarningItem>Remove access to premium features</WarningItem>
                  <WarningItem>Cannot be undone</WarningItem>
                </WarningList>
              </RevokeWarning>
              <ConfirmButtonContainer>
                <CancelButton 
                  onClick={() => setShowRevokeConfirm(false)}
                  disabled={isRevoking}
                >
                  CANCEL
                </CancelButton>
                <ConfirmRevokeButton 
                  onClick={handleRevokeMandate}
                  disabled={isRevoking}
                >
                  <span>{isRevoking ? 'REVOKING...' : 'YES, REVOKE MANDATE'}</span>
                </ConfirmRevokeButton>
              </ConfirmButtonContainer>
            </ModalBody>
          </ModalContent>
        </Box>
      </Modal>
    </SubscriptionContainer>
  );
}

// Styled Components
const SubscriptionContainer = styled.section`
  border: 1px solid #202023;
  margin-top: 46px;
  width: 100%;
  max-width: 900px;
`;

const FormContainer = styled.div``;

const RowContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  width: 100%;
  @media (max-width: 991px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const SubscriptionFormField = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: -0.24px;
  line-height: 130%;
  flex-grow: 1;
  width: 50%;
  @media (max-width: 991px) {
    width: 100%;
  }
`;

const SubscriptionTitle = styled.div`
  font: 800 12px Inter, sans-serif;
  letter-spacing: -0.48px;
  margin-top: 20px;
`;

const UserTypeSelect = styled.select`
  border-radius: 1px;
  border: 1px solid #202023;
  width: 293px;
  max-width: 100%;
  padding: 20px 13px;
  width: 100%;
  margin-right: 10px;
  font: 400 16px/130% Metrophobic, sans-serif;
  margin-top: 5px;
  @media (max-width: 991px) {
    width: 100%;
  }
`;

const SubscriptionInput = styled.input`
  padding-left: 10px;
  padding-right: 10px;
  font: 16px/130% Metrophobic, sans-serif;
  border: 1px solid rgba(32, 32, 35, 1);
  border-radius: 1px;
  margin-top: 5px;
  padding: 20px 13px;
`;

const OptionsContainer = styled.div`
  margin-top: 10px;
  display: flex;
  gap: 20px;
  margin-bottom: 10px;

  @media (max-width: 991px) {
    flex-direction: column;
    gap: 0;
  }
`;

const Option = styled.div`
  width: 50%;
  border: 1px solid rgba(32, 32, 35, 1);
  border-radius: 1px;
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
  cursor: ${props => props.isEditing ? 'pointer' : 'default'};
  padding-bottom: 10px;

  @media (max-width: 991px) {
    margin-top: 10px;
    padding: 10px 10px 10px 10px;
    width: auto;
  }
`;

const OptionLeft = styled.div`
  display: flex;
  flex-direction: column;
`;

const OptionRight = styled.img`
  aspect-ratio: 0.81;
  object-fit: contain;
  height: 100%;
  width: 75px;
  @media (max-width: 991px) {
    aspect-ratio: 0;
  }
`;

const OptionRight2 = styled.img`
  aspect-ratio: 0.81;
  object-fit: contain;
  height: 100%;
  width: 100px;
  @media (max-width: 991px) {
    aspect-ratio: 0;
  }
`;

const OptionIcon = styled.div`
  width: 8px;
  height: 8px;
  fill: #e9fe53;
  border: 1px solid #202023;
  border-radius: 50%;
  padding: 5px;
  background-color: ${props => props.isSelected ? "#e9fe53" : "transparent"};
  position: relative;

  &:after {
    content: ${props => props.isSelected ? "'✓'" : "''"};
    color: #202023;
    font-size: 12px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

const OptionTitle = styled.div`
  margin-top: 16px;
  font: 800 16px/130% Inter, sans-serif;
  @media (max-width: 991px) {
    margin-top: 10px;
  }
`;

const OptionDescription = styled.div`
  letter-spacing: -0.24px;
  margin-top: 10px;
  font: 400 16px/16px Metrophobic, sans-serif;
`;

const OldEditButton_Removed = styled.button`
  display: none;
`;

const SaveButton = styled.button`
  justify-content: space-between;
  border-radius: 1px;
  border: 1px solid rgba(32, 32, 35, 1);
  background-color: #e9fe53;
  display: flex;
  gap: 8px;
  padding: 16px 13px;
  font-family: Metrophobic, sans-serif;
  cursor: pointer;
  width: 260px;  
  text-transform: uppercase;
  @media (max-width: 991px) {
    margin-bottom: 20px;
    width: 100%;
  }
`;

const ButtonIcon = styled.img`
  aspect-ratio: 1.22;
  object-fit: auto;
  object-position: center;
  width: 11px;
  fill: #202023;
  stroke-width: 1px;
  stroke: #202023;
  margin: auto 0;
`;

const MainSubscribeSection = styled.div`
  margin-top: 20px;
  padding: 20px;
  text-align: center;
`;

const MainSubscribeButton = styled.button`
  justify-content: space-between;
  border-radius: 1px;
  border: 1px solid rgba(32, 32, 35, 1);
  background-color: #e9fe53;
  display: flex;
  gap: 8px;
  padding: 16px 13px;
  font-family: Metrophobic, sans-serif;
  cursor: pointer;
  width: 260px;  
  text-transform: uppercase;
  margin: 0 auto 15px auto;
  @media (max-width: 991px) {
    margin-bottom: 15px;
    width: 100%;
  }
`;

const SubscribeHint = styled.div`
  font: 400 14px/130% Inter, sans-serif;
  color: #666;
  text-align: center;
  margin-top: 10px;
`;

const PricingSection = styled.div`
  margin-top: 10px;
  padding: 20px;
  border: 1px solid #202023;
`;

const PricingTitle = styled.div`
  font: 800 12px Inter, sans-serif;
  letter-spacing: -0.48px;
  margin-bottom: 20px;
`;

const PricingBreakdown = styled.div`
  margin-bottom: 20px;
`;

const PriceRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  ${props => props.total && `
    font-weight: 800;
  `}
`;

const PriceLabel = styled.div`
  font: 400 16px/130% Inter, sans-serif;
`;

const PriceValue = styled.div`
  font: 400 16px/130% Inter, sans-serif;
`;

const PriceDivider = styled.div`
  height: 1px;
  background-color: #202023;
  margin: 20px 0;
`;

const SubscribeButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SubscribeButton = styled.button`
  justify-content: space-between;
  border-radius: 1px;
  border: 1px solid rgba(32, 32, 35, 1);
  background-color: #e9fe53;
  display: flex;
  gap: 8px;
  padding: 16px 13px;
  font-family: Metrophobic, sans-serif;
  cursor: pointer;
  width: 260px;  
  text-transform: uppercase;
  @media (max-width: 991px) {
    margin-bottom: 20px;
    width: 100%;
  }
`;

const BackButton = styled.button`
  border: 1px solid rgba(32, 32, 35, 1);
  background-color: #e9fe53;
  text-transform: uppercase;
  letter-spacing: -0.24px;
  justify-content: center;
  padding: 4px 12px;
  font: 400 12px Metrophobic, sans-serif;
  cursor: pointer;
`;

const CurrentSubscriptionSection = styled.div`
  margin-top: 10px;
  padding: 0;
`;

const SubscriptionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const SubscriptionDetailsTitle = styled.div`
  font: 800 12px Inter, sans-serif;
  letter-spacing: -0.48px;
`;

const ViewDetailsButton = styled.button`
  border: 1px solid rgba(32, 32, 35, 1);
  background-color: #e9fe53;
  text-transform: uppercase;
  letter-spacing: -0.24px;
  justify-content: center;
  padding: 4px 12px;
  font: 400 12px Metrophobic, sans-serif;
  cursor: pointer;
`;

const CompactSubscriptionView = styled.div`
  margin-bottom: 20px;
`;

const StatusRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`;

const StatusInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const StatusLabel = styled.div`
  font: 400 16px/130% Inter, sans-serif;
`;

const StatusValue = styled.div`
  font: 400 16px/130% Inter, sans-serif;
  color: ${props => props.status};
`;

const ValidityInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const RenewButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

const RenewButton = styled.button`
  justify-content: space-between;
  border-radius: 1px;
  border: 1px solid rgba(32, 32, 35, 1);
  background-color: #e9fe53;
  display: flex;
  gap: 8px;
  padding: 16px 13px;
  font-family: Metrophobic, sans-serif;
  cursor: pointer;
  width: 260px;  
  text-transform: uppercase;
`;

const TabEditButton = styled.button`
  border: 1px solid rgba(32, 32, 35, 1);
  background-color: #fff;
  text-transform: uppercase;
  letter-spacing: -0.24px;
  justify-content: center;
  padding: 4px 12px;
  font: 800 12px Inter, sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  &:hover {
    background-color: #f5f5f5;
  }
`;

const ActionButtonsGroup = styled.div`
  display: flex;
  gap: 10px;
`;

const EditSectionContainer = styled.div`
  animation: fadeIn 0.3s ease-in-out;
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-10px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

const SectionDivider = styled.div`
  height: 1px;
  background-color: #eee;
  margin: 30px 0;
`;

const WaivedBadge = styled.span`
  margin-left: 8px;
  background-color: #e8f5e9;
  color: #2e7d32;
  padding: 2px 8px;
  borderRadius: 12px;
  fontSize: 11px;
  font-weight: 600;
`;

const SmallLoader = styled.div`
  font: 400 14px Metrophobic, sans-serif;
  color: #666;
  padding: 20px 0;
`;

const NoSubscriptionView = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
`;

const ModalContent = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  max-width: 600px;
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const ModalTitle = styled.h2`
  font: 800 18px Inter, sans-serif;
  letter-spacing: -0.72px;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font: inherit;
  cursor: pointer;
  outline: inherit;
`;

const ModalBody = styled.div`
  margin-bottom: 20px;
`;

const ModalSectionTitle = styled.h3`
  font: 800 16px Inter, sans-serif;
  letter-spacing: -0.64px;
  margin-bottom: 10px;
`;

const modalStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  zIndex: 999
};

const SubscriptionDetails = styled.div`
  margin-bottom: 20px;
`;

const DetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`;

const DetailLabel = styled.div`
  font: 400 16px/130% Inter, sans-serif;
`;

const DetailValue = styled.div`
  font: 400 16px/130% Inter, sans-serif;
  color: ${props => props.status};
`;

const RevokeButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

const RevokeButton = styled.button`
  justify-content: space-between;
  border-radius: 1px;
  border: 1px solid rgba(32, 32, 35, 1);
  background-color: #e9fe53;
  display: flex;
  gap: 8px;
  padding: 16px 13px;
  font-family: Metrophobic, sans-serif;
  cursor: pointer;
  width: 260px;  
  text-transform: uppercase;
`;

const RevokeWarning = styled.div`
  margin-bottom: 20px;
`;

const WarningText = styled.div`
  font: 400 16px/130% Inter, sans-serif;
  margin-bottom: 10px;
`;

const WarningList = styled.ul`
  list-style-type: disc;
  padding-left: 20px;
`;

const WarningItem = styled.li`
  font: 400 16px/130% Inter, sans-serif;
`;

const ConfirmButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const CancelButton = styled.button`
  border: 1px solid rgba(32, 32, 35, 1);
  background-color: #e9fe53;
  text-transform: uppercase;
  letter-spacing: -0.24px;
  justify-content: center;
  padding: 4px 12px;
  font: 400 12px Metrophobic, sans-serif;
  cursor: pointer;
  ${props => props.disabled && `
    opacity: 0.5;
    cursor: not-allowed;
  `}
`;

const ConfirmRevokeButton = styled.button`
  border: 1px solid rgba(32, 32, 35, 1);
  background-color: #e9fe53;
  text-transform: uppercase;
  letter-spacing: -0.24px;
  justify-content: center;
  padding: 4px 12px;
  font: 400 12px Metrophobic, sans-serif;
  cursor: pointer;
  ${props => props.disabled && `
    opacity: 0.5;
    cursor: not-allowed;
  `}
`;

export default Subscription; 